<template lang="pug">
  .leads.white
    v-container.pa-0(style="max-width:600px")
      div.p2.px-4.py-3.mb-2.basic600.basic100--text.clickable(v-if="ongoingCount > 0" @click="$store.commit('riders/updateOpenOngoingDialog', true)") {{ $tc('ongoing_orders', ongoingCount) }}
      div.pa-0.main-container
        v-tabs(v-model="tab" fixed-tabs color="textColorAccent" height="40" slider-size="4")
          v-tab.button-AA-small.px-0 {{ $t('processing') }} {{ processingCount > 0 ? '(' + processingCount + ')' : '' }}
          v-tab.button-AA-small.px-0 {{ $t('shipping_tab') }} {{ shippingCount > 0 ? '(' + shippingCount + ')' : '' }}
          v-tab.button-AA-small.px-0 {{ $t('completed') }}
        div.separator(:style="{ 'background-color':$vuetify.theme.themes[$theme].basic600T16 }")
      div
        v-tabs-items(v-model="tab" touchless)
          v-tab-item
            template(v-if="tab === 0")
              template(v-if="view === 'list'")
                order-list-view(ref="orders" :company="company" :menu="menu")
              template(v-if="view === 'calendar'")
                order-calendar-view(ref="orders" :company="company" :menu="menu")
              template(v-if="view === 'kanban'")
                order-kanban-view(ref="orders" :company="company" :menu="menu")
          v-tab-item
            order-shipping(v-if="tab === 1" :company="company" :menu="menu")
          v-tab-item
            order-completed(v-if="tab === 2" :company="company" :menu="menu")
    .dialog
      ongoing(v-if="openOngoingDialog" :open="openOngoingDialog")
      order-item-details(v-if="openOrderItemDetailsDialog" :open.sync="openOrderItemDetailsDialog" :parentLead.sync="oneLead" @deleted="handleDeletedItem")
</template>

<script>
// import { mapState, mapActions } from 'vuex'
// import queryString from 'query-string'
// import OrderItem from '@/components/OrderItem.vue'
import { mapState, mapGetters } from 'vuex'
import OrderListView from '@/components/ordermgmt/OrderListView.vue'
import OrderCalendarView from '@/components/ordermgmt/OrderCalendarView.vue'
import OrderKanbanView from '@/components/ordermgmt/OrderKanbanView.vue'
import OrderShipping from '@/components/ordermgmt/OrderShipping.vue'
import OrderCompleted from '@/components/ordermgmt/OrderCompleted.vue'
import Ongoing from '@/components/dialogs/yezzashipping/ongoing/Ongoing.vue'
import OrderItemDetails from '@/components/dialogs/order/OrderItemDetails.vue'

export default {
  name: 'OrdersNew',
  components: { OrderListView, OrderCalendarView, OrderKanbanView, OrderShipping, OrderCompleted, Ongoing, OrderItemDetails },
  props: ['company', 'menu'],
  data: () => ({
    tab: null,
    processingCount: 0,
    shippingCount: 0,
    // For redirect from notification only
    oneLead: null,
    openOrderItemDetailsDialog: false
  }),
  computed: {
    ...mapState('user', ['user', 'member']),
    ...mapState('riders', ['refetchOneOrder', 'refetchAllOrders', 'openOngoingDialog']),
    ...mapGetters({
      view: 'orders/getOrderView',
      ongoingCount: 'riders/getOngoingCount'
    })
  },
  mounted() {
    this.fullscreen = window.innerWidth < 600
    this.fetchZones()
    this.$store.commit('orders/recoverOrderViewDetails')
    this.getCountOrder()
    this.orderTourCheck()
    this.fetchOngoing()
    // For redirect from notification only
    if (this.$route.query.order) {
      this.showOneOrder(this.$route.query.order)
    }
  },
  watch: {
    refetchOneOrder(val) {
      if (val) {
        this.refetchOneOrderAction(val)
        this.$store.commit('riders/updateRefetchOneOrder', null)
      }
    },
    refetchAllOrders(val) {
      if (val) {
        this.refetchAllOrdersAction()
        this.$store.commit('riders/updateRefetchAllOrders', false)
      }
    },
    tab(val) {
      this.$store.commit('orders/resetFilters')
      this.$store.commit('orders/resetLeads', false)
      this.getCountOrder()
      this.$router.replace({ query: null }).catch(() => {})
      this.$store.commit('orders/setSelectedTab', val)
    }
  },
  methods: {
    fetchZones() {
      this.$axios
        .get(`/shipping/settings/${this.company.slug}/zones`)
        .then(response => {
          this.$store.commit('orders/setZoneCount', response.data.count)
        })
        .catch(() => {})
    },
    getCountOrder() {
      const params = { form__company: this.company.id, form_type_exclude: 'book_income' }
      if (this.member.role !== 'Admin') {
        params.append('member', this.member.id)
      }
      this.$axios
        .get('/leads/', { params: { ...params, status: 'processed' } })
        .then(response => {
          this.processingCount = response.data.count
        })
        .catch(() => {})
      this.$axios
        .get('/leads/', { params: { ...params, status: 'shipped' } })
        .then(response => {
          this.shippingCount = response.data.count
        })
        .catch(() => {})
    },
    orderTourCheck() {
      this.$axios
        .get(`/companies/${this.company.id}/settings`)
        .then(resp => {
          if (resp.data.results.length > 0) {
            if (resp.data.results.filter(f => f.name === 'yz.order_mgmt.tour').length > 0) {
              let tourSettings = resp.data.results.filter(f => f.name === 'yz.order_mgmt.tour')[0]
              this.$store.commit('tours/setOrderTempData', { company: this.company.id, ...tourSettings })
            } else {
              this.$axios
                .post(`/companies/${this.company.id}/settings`, { name: 'yz.order_mgmt.tour', value: 'touring', extra_data: {} })
                .then(resp2 => {
                  this.$store.commit('tours/setOrderTempData', { company: this.company.id, ...resp2.data })
                })
                .catch(() => {})
            }
          } else {
            this.$axios
              .post(`/companies/${this.company.id}/settings`, { name: 'yz.order_mgmt.tour', value: 'touring', extra_data: {} })
              .then(resp2 => {
                this.$store.commit('tours/setOrderTempData', { company: this.company.id, ...resp2.data })
              })
              .catch(() => {})
          }
        })
        .catch(() => {})
    },
    fetchOngoing() {
      const params = { company: this.company.id }
      this.$axios
        .get('/shipping/yezzashipping/ongoing', { params })
        .then(resp => {
          this.$store.commit('riders/updateOngoingData', resp.data)
        })
        .catch(() => {})
    },
    refetchOneOrderAction(leadPid) {
      if (this.view === 'kanban') {
        if (this.$refs.orders.status === 0) {
          this.$refs.orders.$refs.processing.fetchOneLead(leadPid)
        } else {
          this.$refs.orders.$refs.ready.fetchOneLead(leadPid)
        }
      } else {
        this.$refs.orders.fetchOneLead(leadPid)
      }
    },
    refetchAllOrdersAction() {
      if (this.view === 'kanban') {
        if (this.$refs.orders.status === 0) {
          this.$refs.orders.$refs.processing.fetchLeads(this.$route.query.page || 1)
        } else {
          this.$refs.orders.$refs.ready.fetchLeads(this.$route.query.page || 1)
        }
      } else {
        this.$refs.orders.fetchLeads(this.$route.query.page || 1)
      }
    },
    openFeedback() {
      window.open('https://yezzaio.typeform.com/to/uFy9gsAL')
    },
    // For redirect from notification only
    showOneOrder(leadRid) {
      const params = {
        rid: leadRid,
        company: this.company.id
      }
      this.$axios
        .get('/leads/', { params })
        .then(resp => {
          this.oneLead = resp.data.results[0]
          this.openOrderItemDetailsDialog = true
        })
        .catch(() => {})
    },
    // For redirect from notification only
    handleDeletedItem() {
      this.refetchAllOrdersAction()
    }
  }
}
</script>

<style scoped>
.main-container {
  position: relative;
}
.separator {
  position: absolute;
  height: 4px;
  top: 36px;
  left: 0px;
  right: 0px;
}
</style>

<i18n>
{
 
}
</i18n>
